<template>
  <div>
    <!-- active & hover classes 'bg-primary-100 dark:bg-primary-600' -->
    <a
      v-bind:href="href"
      v-on:click="openSubmenu"
      class="
        flex
        items-center
        p-2
        text-gray-500
        transition-colors
        dark:text-light
        hover:bg-primary-100
        dark:hover:bg-primary-600
      "
      v-bind:class="{
        'bg-primary-100 dark:bg-primary-600': isActive || open,
      }"
      role="button"
      aria-haspopup="true"
      v-bind:aria-expanded="open || isActive ? 'true' : 'false'"
    >
      <span aria-hidden="true">
        <i class="fa" v-bind:class="icon"></i>
      </span>
      <span class="ml-2 text-sm">{{ text }}</span>
      <!-- chevron -->
      <span v-if="hasSubitems" class="ml-auto" aria-hidden="true">
        <!-- active class 'rotate-180' -->
        <svg
          class="w-4 h-4 transition-transform transform"
          v-bind:class="{ 'rotate-180': open }"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </span>
    </a>
    <div
      role="menu"
      v-show="open"
      class="mt-2 space-y-2 pv-7"
      v-bind:aria-label="text"
    >
      <!-- active & hover classes 'text-gray-700 dark:text-light' -->
      <!-- inActive classes 'text-gray-400 dark:text-gray-400' -->
      <span v-if="hasSubitems">
        <a
          v-for="item in items"
          v-bind:key="item.href"
          v-bind:href="item.href"
          role="menuitem"
          class="
            block
            p-2
            text-sm text-gray-400
            transition-colors
            duration-200
            bg-gray-800
            dark:text-gray-400
            dark:hover:text-light
            hover:text-gray-700
            hover:bg-primary-50
          "
        >
          {{ item.text }}
        </a>
      </span>
    </div>
  </div>
</template>


<script>
export default {
  props: {
    icon: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
    href: {
        type: String,
        requried: false,
        default: "#"
    },
    items: {
      type: Array,
      required: false,
      default: null,
    },
  },

  data() {
    return {
      isActive: false,
      open: false,
    };
  },

  computed: {
    hasSubitems() {
      return !!this.items && !!this.items.length;
    },
  },

  methods: {
    openSubmenu($event) {
      if (this.hasSubitems) {
        this.open = !this.open;
        $event.preventDefault();
      }
    },
  },
};
</script>
